// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cdr-report-container,
.cdr-map-container,
.cdr-accordion-container {
  display: flex;
  justify-content: center;
  width: 100%; }
  .cdr-report-container .tables-container,
  .cdr-map-container .tables-container,
  .cdr-accordion-container .tables-container {
    height: 40vh;
    overflow: auto; }
    .cdr-report-container .tables-container .paginate-btn,
    .cdr-map-container .tables-container .paginate-btn,
    .cdr-accordion-container .tables-container .paginate-btn {
      background-color: #0b1736;
      color: white;
      border-radius: 4px; }
      .cdr-report-container .tables-container .paginate-btn svg,
      .cdr-map-container .tables-container .paginate-btn svg,
      .cdr-accordion-container .tables-container .paginate-btn svg {
        color: white; }
    .cdr-report-container .tables-container table,
    .cdr-map-container .tables-container table,
    .cdr-accordion-container .tables-container table {
      color: #ffffffff !important; }
      .cdr-report-container .tables-container table thead,
      .cdr-report-container .tables-container table tbody,
      .cdr-map-container .tables-container table thead,
      .cdr-map-container .tables-container table tbody,
      .cdr-accordion-container .tables-container table thead,
      .cdr-accordion-container .tables-container table tbody {
        font-size: 16px;
        font-weight: bold; }
      .cdr-report-container .tables-container table thead th,
      .cdr-map-container .tables-container table thead th,
      .cdr-accordion-container .tables-container table thead th {
        inset-inline-start: unset !important; }
  .cdr-report-container .button-box,
  .cdr-map-container .button-box,
  .cdr-accordion-container .button-box {
    display: flex;
    justify-content: flex-end; }
  .cdr-report-container .tables-container::-webkit-scrollbar,
  .cdr-map-container .tables-container::-webkit-scrollbar,
  .cdr-accordion-container .tables-container::-webkit-scrollbar {
    width: 0.5em; }
  .cdr-report-container .tables-container::-webkit-scrollbar-track,
  .cdr-map-container .tables-container::-webkit-scrollbar-track,
  .cdr-accordion-container .tables-container::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); }
  .cdr-report-container .tables-container::-webkit-scrollbar-thumb,
  .cdr-map-container .tables-container::-webkit-scrollbar-thumb,
  .cdr-accordion-container .tables-container::-webkit-scrollbar-thumb {
    background-color: darkgrey;
    outline: 1px solid slategrey; }

h1 {
  color: white; }

.expanded {
  position: absolute;
  top: 10%;
  height: 90vh !important;
  background-color: #050e25;
  z-index: 100;
  left: 5%; }
`, "",{"version":3,"sources":["webpack://./src/features/reports/ChemicalDataReporting/cdr-styles.scss"],"names":[],"mappings":"AAAA;;;EAGE,aAAa;EACb,uBAAuB;EACvB,WAAW,EAAA;EALb;;;IAQI,YAAY;IACZ,cAAc,EAAA;IATlB;;;MAWM,yBAAyB;MACzB,YAAY;MACZ,kBAAkB,EAAA;MAbxB;;;QAeQ,YAAY,EAAA;IAfpB;;;MAmBM,2BAA2B,EAAA;MAnBjC;;;;;;QAsBQ,eAAe;QACf,iBAAiB,EAAA;MAvBzB;;;QA2BU,oCAAoC,EAAA;EA3B9C;;;IAmCI,aAAa;IACb,yBAAyB,EAAA;EApC7B;;;IAwCI,YAAY,EAAA;EAxChB;;;IA4CI,4CAA4C,EAAA;EA5ChD;;;IAgDI,0BAA0B;IAC1B,4BAA4B,EAAA;;AAIhC;EAAK,YAAa,EAAA;;AAElB;EACE,kBAAkB;EAClB,QAAQ;EACR,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,QAAQ,EAAA","sourcesContent":[".cdr-report-container,\n.cdr-map-container,\n.cdr-accordion-container {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n\n  .tables-container {\n    height: 40vh;\n    overflow: auto;\n    .paginate-btn {\n      background-color: #0b1736;\n      color: white;\n      border-radius: 4px;\n      svg {\n        color: white;\n      }\n    }\n    table {\n      color: #ffffffff !important;\n      thead,\n      tbody {\n        font-size: 16px;\n        font-weight: bold;\n      }\n      thead {\n        th {\n          inset-inline-start: unset !important;\n        }\n      }\n    }\n   \n  }\n\n  .button-box {\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  .tables-container::-webkit-scrollbar {\n    width: 0.5em;\n  }\n\n  .tables-container::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  }\n\n  .tables-container::-webkit-scrollbar-thumb {\n    background-color: darkgrey;\n    outline: 1px solid slategrey;\n  }\n}\n\nh1 { color: white }\n\n.expanded {\n  position: absolute;\n  top: 10%;\n  height: 90vh !important;\n  background-color: #050e25;\n  z-index: 100;\n  left: 5%;\n}\n\n// .cdr-map-container {\n//   .header-options-container.text-right {\n//     width: 100%;\n//     display: flex;\n//     flex-direction: row;\n//     align-items: center;\n//     justify-content: flex-end;\n//     button {\n//       margin: 4px;\n//     }\n//   }\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
